import makeService from './api';

export default makeService('action_types');
